import { Link } from "office-ui-fabric-react"

const TimeReportingSettingsTooltip = () => {
    return <span>
        Define time reporting settings for your PPM Express tenant. Please refer to the <Link
            target="_blank"
            href="https://help.ppm.express/89495-ppm-express-settings/2610325-time-tracking-settings#section-0">
                article 
        </Link> for more details.
    </span>
}

export default TimeReportingSettingsTooltip;